import React from 'react';
import './../../style/pages/proyecto-hormiga.scss';
import logoHTC from './../../assets/images/ant-circle.png';
import cuelodebotella from './../../assets/images/cuellodebotella.png';
import escalabilidad from './../../assets/images/protocolexplication.png';
import mariano from './../../assets/images/mariano.jpg';
import { Link } from 'react-router-dom';

const ProyectoHormiga = () => {
    return (
        <div className="proyecto-hormiga">
            <h1> Hormiga</h1>
            <h2>¿Qué es?</h2>

            <p>
                Es una app descentralizada que conecta personas que quieren enviar o transportar productos, usando viajes ya programados. Así se ahorran costos, se acelera la logística y se evita el desperdicio de espacio y energía.
            </p>

            <div className="imagen-container">
                <img src={cuelodebotella} alt="Cuello de botella" className="imagen" />
            </div>

            <h2>¿Cómo funciona?</h2>
            <p>
                Cada envío se asegura con un contrato inteligente que congela tokens <strong>HTC</strong> como colateral. Si el envío falla, el receptor puede reclamar el valor declarado. Esto genera seguridad sin necesidad de intermediarios.
            </p>

            <div className="imagen-container">
                <img src={escalabilidad} alt="Explicación del protocolo" className="imagen" />
            </div>

            <h2>¿Qué es el token HTC?</h2>
            <p>
                Es un token ERC-20 con emisión limitada (7 billones), que actúa como unidad de valor para el transporte dentro del sistema. Su precio se define por la oferta, la demanda y su utilidad real.
            </p>
            <p>
                Ahora el <strong>HTC</strong> ya se puede adquirir desde el <Link to="/swap" style={{ color: 'green', textDecoration: 'underline' }}>Swap</Link> integrado en la aplicación.
            </p>

            <div className="imagen-container">
                <img src={logoHTC} alt="Logo HTC" className="imagen" />
            </div>

            <h2>Incentivos y confianza</h2>
            <p>
                Al declarar el valor del bien enviado, el usuario define el monto del colateral. Esto motiva a los transportistas a cumplir, ya que al entregar el paquete, reciben una recompensa previamente acordada.
            </p>

            <h2>¿Quién lo creó?</h2>
            <div className="imagen-container">
                <img src={mariano} alt="Mariano" className="imagen" />
            </div>
            <p>
                Mariano Privitera, fundador del proyecto, impulsa esta herramienta como una alternativa para descentralizar la logística, generar oportunidades y aprovechar recursos que hasta ahora eran desperdiciados.
            </p>
        </div>
    );
};

export default ProyectoHormiga;
